import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { RouteComponentProps } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import Page from 'components/Page'
import Current from 'components/Page/Tank/Current'
import History from 'components/Page/Tank/History'
import * as beacon from 'utils/beacon'
import { setLoader } from 'utils/loader'
import { getTankInfo, getTankReadings } from 'http/tank'
import { transformTank, getGeoInfo, getGeoInfoTracker, toTitleCase } from 'utils/common'
import { UsagePeriod, User, Role } from 'types'
import { Link } from 'react-router-dom'
import { TRACKERTYPES } from 'utils/constants'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const convertHistoryData = (role: Role, tank: any, data: any[]) => {
  const history = []
  let alarm = 0
  let settings = null
  var pressure;

  if (tank.settings) {
    settings = tank.settings
    if (tank.settings.reorder) {
      alarm = settings.reorder
    }
  }
  for (let i = 0; i < data.length; i++) {
    const raw = beacon.convertRaw(data[i].raw)
    raw.dporhe = tank.dporhe;
    if (tank.capacity != undefined && tank.capacity == 181) {
      raw.capacity = tank.capacity;
    }
    if (tank.pvalue != undefined) {
      raw.pvalue = tank.pvalue;
    }
    // Manifold getting 110 - this  case not present in calLevel (wrong data ignored)
    let ignoreRaw = raw.status.substring(4, 7);
    if (ignoreRaw == '110') {
      continue;
    }
    const value = Math.min(beacon.calcLevel(raw, settings), 120)
    //Pressure Calculations
    if (tank.type == 'bulk' || (tank.info !== undefined && tank.info.data !== undefined && tank.info.data.type == 'bulk')) {
      pressure = raw.sensor2;
    }
    if (tank.type == 'pack' && raw.sensor1 != undefined) {
      pressure = (raw.sensor1 / 10)
    }

    if (value.toString().toLowerCase().indexOf('e') < 0) {
      //Skip levle above 200 from calculations.
      if (Math.round(value * 100) > 200) {
        continue;
      }
      if (role === Role.ADMIN) {
        history.push([
          new Date(data[i].datetime),
          Math.round(value * 100),
          alarm,
          (raw.mbat / 3.6) * 100,
          (tank.type.toString().indexOf('manifold') !== -1 || tank.type.toString().toUpperCase() === 'BLEREADER') ? raw.sbat : (raw.sbat / 12) * 100,
          pressure
        ])
      } else {
        history.push([new Date(data[i].datetime), Math.round(value * 100)])
      }
    }
  }
  return history
}

const calculateHistoryChartData = async (role: Role, history: any[], from: number) => {
  const chartData = []
  let lines = [
    {
      type: 'datetime',
      label: 'Time of Day',
    },
    {
      type: 'number',
      label: 'Level in %',
    },
  ]

  if (role === Role.ADMIN) {
    lines = lines.concat([
      {
        type: 'number',
        label: 'Order Level',
      },
      {
        type: 'number',
        label: 'Battery Percentage',
      },
      {
        type: 'number',
        label: 'Secondary Battery Percentage',
      },
    ])
  }
  chartData.push(lines)

  const fromDate = new Date(from)
  for (let i = 0; i < history.length; i++) {
    if (history[i][0] > fromDate) {
      if (history[i][1] <= 200) {
        var objArrParent = [];
        objArrParent[0] = history[i][0];
        objArrParent[1] = history[i][1];
        if (role === Role.ADMIN) {
          objArrParent[2] = history[i][2];
          objArrParent[3] = history[i][3];
          objArrParent[4] = history[i][4];
        }
        chartData.push(objArrParent)
        //chartData.push(history[i])
      }
    }
  }
  return chartData
}

//Pressure data
const calculateHistoryChartDataPressure = async (role: Role, history: any[], from: number) => {
  const chartDataPressure = []
  let lines = [
    {
      type: 'datetime',
      label: 'Time of Day',
    },
    {
      type: 'number',
      label: 'Pressure(Bar)',
    },
  ]

  chartDataPressure.push(lines)

  const fromDate = new Date(from)
  for (let i = 0; i < history.length; i++) {
    if (history[i][0] > fromDate) {
      if (history[i][1] <= 200) {
        var objArrParent = [];
        objArrParent[0] = history[i][0];
        objArrParent[1] = history[i][5];
        chartDataPressure.push(objArrParent)
      }
    }
  }
  return chartDataPressure
}


const calcFlowRate = (tank: any, tankHistory: any, usagePeriod: UsagePeriod) => {
  const { from, to } = usagePeriod
  let historyFrom = -1
  let historyTo = -1

  for (let i = 0; i < tankHistory.length; i++) {
    if (from <= tankHistory[i][0] && historyFrom == -1) {
      historyFrom = i
    } else if (to <= tankHistory[i][0] || i == tankHistory.length - 1) {
      historyTo = i
      break
    }
  }

  if (tankHistory.length === 0) {
    return {
      error: 'No Data',
    }
  } else if (from > tankHistory[tankHistory.length - 1][0]) {
    return {
      error: 'Not Applicable',
    }
  } else {
    var preValue;
    var finalDiff;

    for (var i = historyFrom; i <= historyTo; i++) {
      let percentageChange;
      if (preValue != undefined) {
        percentageChange = ((tankHistory[i][1] - preValue) / preValue) * 100;
        var diff1;
        if (percentageChange > 20) {
          //continue;   
        }
        else {
          diff1 = preValue - tankHistory[i][1];
          if (finalDiff == undefined) {
            finalDiff = diff1;
          }
          else {
            finalDiff = finalDiff + diff1;
          }
        }
      }
      if (tankHistory[i] != undefined) {
        preValue = tankHistory[i][1];
      }
      else {
        return {
          error: 'No Data Applicable',
        }
      }
    }

    // If click on last data point and current radio selection is From Date
    if (tankHistory.length - historyFrom <= 1) {
      return;
    }

    const hours = ((tankHistory[historyFrom][0] - tankHistory[historyTo][0]) / 1000 / 60 / 60) * -1
    let m3;
    if (finalDiff > 0 && tank.capacity > 0) {
      m3 = (finalDiff / 100) * tank.capacity
    }
    else {
      m3 = 0;
    }
    //Display usage as 0 for levle up ( previous code was showing negative usage)
    if (m3 < 0) {
      m3 = 0;
    }
    const ph = m3 / hours
    return {
      m3,
      hours,
      ph,
    }
  }
}

interface MatchParams {
  tankId: string
}

interface IProps extends RouteComponentProps<MatchParams> {
  user: User
}

interface IState {
  searching: boolean
  showHistory: boolean
  historySwitchDisabled: boolean
  historyChartData: any[]
  historyChartDataPressure: any[]
  flowRate: any
  usagePeriod: UsagePeriod
  period: number
  tank: any
  geo: any[]
  optionSelected: string
  fromindex: number
  toindex: number
  isfromselected: boolean
  istoseleced: boolean
  chartType: string
}

class Tank extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      searching: true,
      historyChartData: [],
      historyChartDataPressure: [],
      flowRate: {
        error: 'No Data',
      },
      usagePeriod: {
        from: new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
        to: new Date(),
      },
      period: 7,
      showHistory: false,
      historySwitchDisabled: true,
      tank: null,
      geo: [],
      optionSelected: 'fromDate',
      fromindex: 0,
      toindex: 0,
      isfromselected: false,
      istoseleced: false,
      chartType: 'level'
    }
    this.tankHistory = []
    this.historyFrom = new Date().getTime() - this.state.period * 24 * 60 * 60 * 1000
    this.historyTo = new Date().getTime()
  }

  tankHistory = []
  historyFrom = 0
  historyTo = 0

  async componentDidMount() {
    setLoader(true)
    try {
      const { usagePeriod } = this.state
      const { user } = this.props
      const tankId = this.props.match.params.tankId
      localStorage.setItem('deviceID', tankId);
      const data = await getTankInfo(this.props.match.params.tankId)
      const tank = transformTank(data.data[tankId])
      if (TRACKERTYPES.includes(tank.type) || tank.type === 'pack') {
        const geonew = getGeoInfoTracker(tank)
        let geo = [];
        geo.push(geonew);
        this.setState(state => ({
          ...state,
          tank,
          geo,
        }))
      }
      else {
        const geo = getGeoInfo(tank)
        this.setState(state => ({
          ...state,
          tank,
          geo,
        }))
      }

      if (user.role !== Role.CUSTOMER || !TRACKERTYPES.includes(tank.type)) {
        let historyChartData = []
        let historyChartDataPressure = []
        let flowRate = {}
        if (tank.sensor) {
          const { data } = await getTankReadings(tankId, this.historyFrom, this.historyTo)
          this.tankHistory = convertHistoryData(user.role, tank, data)
          historyChartData = await calculateHistoryChartData(user.role, this.tankHistory, this.historyFrom)

          this.setState(state => ({
            ...state,
            fromindex: -1,  //on load no date selected so set as -1
            toindex: - 1,
          }))
          historyChartData.forEach(function (row, index) {
            if (index == 0) {
              row.splice(2, 0, { role: 'style', type: 'string' });
            } else {
              row.splice(2, 0, null)
            }
          });
        }


        //Pressure chart
        historyChartDataPressure = await calculateHistoryChartDataPressure(user.role, this.tankHistory, this.historyFrom)
        historyChartDataPressure.forEach(function (row, index) {
          if (index == 0) {
            row.splice(2, 0, { role: 'style', type: 'string' });
          } else {
            row.splice(2, 0, null)
          }
        });
        const usagePeriod = {
          ...this.state.usagePeriod,
          from: new Date('12/12/9999'),
          to: new Date('12/12/9999'),
        }
        this.setState({
          ...this.state,
          usagePeriod
        })
        flowRate = calcFlowRate(tank, this.tankHistory, usagePeriod)
        this.setState(state => ({
          ...state,
          historyChartData,
          historyChartDataPressure,
          flowRate,
          historySwitchDisabled: false,
        }))
      }
    } catch (error) {
      console.log(error)
    }
    this.setState(state => ({
      ...state,
      searching: false,
    }))
    setLoader(false)
  }

  _handlePeriodChange = async (period: number) => {
    if (period === this.state.period) return
    const { user } = this.props
    const delta = (this.historyTo - this.historyFrom) / 1000 / 60 / 60 / 24
    const { tank } = this.state
    const usagePeriod = {
      ...this.state.usagePeriod,
      from: new Date('12/12/9999'),
      to: new Date('12/12/9999'),
    }
    this.setState(state => ({
      ...state,
      usagePeriod,
      optionSelected: 'fromDate',
      isfromselected: false,
      istoseleced: false,
      fromindex: -1,
      toindex: -1
    }))

    if (period > delta) {
      this.historyFrom = this.historyTo - period * 24 * 60 * 60 * 1000
      if (tank.sensor) {
        setLoader(true)
        const { data } = await getTankReadings(tank.deviceID, this.historyFrom, this.historyTo)
        setLoader(false)
        this.tankHistory = convertHistoryData(user.role, tank, data)
      }
    }
    const from = this.historyTo - period * 24 * 60 * 60 * 1000
    const historyChartData = await calculateHistoryChartData(user.role, this.tankHistory, from)
    historyChartData.forEach(function (row, index) {
      if (index == 0) {
        row.splice(2, 0, { role: 'style', type: 'string' });
      } else {
        const rowNull = row.indexOf(null);
        const rowFormat = row.indexOf('point {size: 4}');
        if (rowNull > -1) {
          row.splice(rowNull, 1);
        }
        else if (rowFormat > -1) {
          row.splice(rowFormat, 1);
        }
        row.splice(2, 0, null)
      }
    });

    //Pressure chart
    const historyChartDataPressure = await calculateHistoryChartDataPressure(user.role, this.tankHistory, from)
    historyChartDataPressure.forEach(function (row, index) {
      if (index == 0) {
        row.splice(2, 0, { role: 'style', type: 'string' });
      } else {
        const rowNull = row.indexOf(null);
        const rowFormat = row.indexOf('point {size: 4}');
        if (rowNull > -1) {
          row.splice(rowNull, 1);
        }
        else if (rowFormat > -1) {
          row.splice(rowFormat, 1);
        }
        row.splice(2, 0, null)
      }
    });

    this.setState({
      ...this.state,
      historyChartData,
      historyChartDataPressure,
      period,
    })
  }

  _handleFocusChange = evt => {
    let optionSelectedValue = evt.target.value
    let fromindex = this.state.fromindex + 1;
    let toindex = this.state.toindex + 1
    this.state.historyChartData.forEach(function (row, index) {
      if (index == 0) {
      } else {
        const rowNull = row.indexOf(null);
        const rowFormat = row.indexOf('point {size: 4}');
        if (rowNull > -1) {
          row.splice(rowNull, 1);
        }
        else if (rowFormat > -1) {
          row.splice(rowFormat, 1);
        }
        if (index == fromindex || index == toindex) {
          row.splice(2, 0, 'point {size: 4}')
        }
        else {
          row.splice(2, 0, null)
        }
      }
    });
    this.setState(state => ({
      ...state,
      optionSelected: optionSelectedValue,
    }))
  }
  _handleUsagePeriodChange = evt => {
    const { tank } = this.state
    if (this.state.optionSelected == 'fromDate') {
      const usagePeriod = {
        ...this.state.usagePeriod,
        from: new Date(evt),
      }
      this.setState({
        ...this.state,
        usagePeriod,
        isfromselected: true,
        flowRate: calcFlowRate(tank, this.tankHistory, usagePeriod),
      })
    }
    else {
      const usagePeriod = {
        ...this.state.usagePeriod,
        to: new Date(evt),
      }
      this.setState({
        ...this.state,
        usagePeriod,
        istoseleced: true,
        flowRate: calcFlowRate(tank, this.tankHistory, usagePeriod),
      })
    }
    let rowSelected;
    //9999 date is declared at page load - as on load date should be not selected'
    let invalidFromDate = new Date(this.state.usagePeriod.from).getFullYear();
    let invalidToDate = new Date(this.state.usagePeriod.to).getFullYear();

    let isToDate = false;
    for (var i = 1; i < this.state.historyChartData.length; i++) {
      if (invalidFromDate != 9999 && (this.state.historyChartData[i][0]).toString() == this.state.usagePeriod.from.toString()) {
        this.setState(state => ({
          ...state,
          fromindex: i - 1,  //Column 0 contains style so index-1
        }))
      }

      if (invalidToDate != 9999 && (this.state.historyChartData[i][0]).toString() == this.state.usagePeriod.to.toString()) {
        isToDate = true;
        this.setState(state => ({
          ...state,
          toindex: i - 1, //Column 0 contains style so index-1
        }))
      }
    }

    if (this.state.toindex != -1) {
      rowSelected = Number(this.state.fromindex) + ',' + Number(this.state.toindex);
    }
    else {
      rowSelected = Number(this.state.fromindex)
    }
    return rowSelected
  }

  _toggleHistoryView = () => {
    this.setState({
      ...this.state,
      showHistory: !this.state.showHistory,
    })
  }

  //Send Notification
  btnNotificatonSettings = (tankId) => {
    this.props.history.push(`/settings/${tankId}`)
  }

  //Toggle chart Gas :evel Or Pressure
  handleChange = (event) => {
    //setValue(event.target.value);
    var type = event.target.value
    this.setState(state => ({
      ...state,
      chartType: type
    }))
  };
  render() {
    const {
      searching,
      historyChartData,
      historyChartDataPressure,
      flowRate,
      tank,
      geo,
      showHistory,
      historySwitchDisabled,
      period,
      usagePeriod,
      optionSelected,
      isfromselected,
      istoseleced,
      chartType
    } = this.state
    const { user } = this.props

    let header = ''
    if (tank) {
      if (user.role === Role.ADMIN || user.role === Role.CUSTOMER) {
        header = `${tank.sh} ${tank.name}`
      }
    }
    return (
      <Page title="Tank Info">
        {!searching && !tank && <p>Tank Not Found</p>}
        {tank && (
          <Grid container direction="column">
            <Grid item>
              <Box
                mb={{ xs: 2 }}
                p={{ xs: 1 }}
                style={{
                  backgroundColor: '#ebe3cd',
                }}
              >
                <Typography variant="h4" color="secondary">
                  {header}
                </Typography>
              </Box>
            </Grid>
            <Grid container alignItems="baseline">
              {!TRACKERTYPES.includes(tank.type) && (<Grid item>
                <Typography variant="h4">View History</Typography>
              </Grid>)}
              {!TRACKERTYPES.includes(tank.type) && (<Grid item>
                <Switch
                  color="secondary"
                  disabled={historySwitchDisabled}
                  onChange={this._toggleHistoryView}
                  checked={showHistory}
                />
              </Grid>)}
              {(tank.type == "cryospeed" || tank.type == "gasmatic" || tank.type == "bulk" || tank.type == "pack") && (<Grid item>
                <Button onClick={() => { this.btnNotificatonSettings(tank.deviceID) }}>
                  <Typography color="primary">Settings</Typography>
                </Button>
              </Grid>)}
              {showHistory && (
                <Grid style={{ marginLeft: '40px' }}>
                  <RadioGroup row aria-label="position" name="position" defaultValue="level" onChange={this.handleChange}>
                    <FormControlLabel
                      value="level"
                      control={<Radio color="secondary" />}
                      label="Gas Level"
                      labelPlacement="end"
                    />
                    {(tank.type == 'bulk' || tank.type == 'pack' || (tank.info !== undefined && tank.info.data !== undefined && tank.info.data.type == 'bulk')) && (<FormControlLabel
                      value="pressure"
                      control={<Radio color="secondary" />}
                      label="Pressure"
                      labelPlacement="end"
                    />)}
                  </RadioGroup>
                </Grid>)}
              <Grid item style={{ marginLeft: "auto" }}>
                <Link to="/">
                  <Box ml={{ xs: 2, sm: 3, md: 5, lg: 8, xl: 10 }}>
                    Go Back
                </Box>
                </Link>
              </Grid>
            </Grid>
            <Grid item>
              {!showHistory && <Current tank={tank} geo={geo} />}
              {showHistory && (
                <History
                  data={historyChartData}
                  dataPressure={historyChartDataPressure}
                  isAdmin={user.role === Role.ADMIN}
                  flowRate={flowRate}
                  tanktype={tank.type}
                  tank={tank}
                  historyPeriod={period}
                  handlePeriodChange={this._handlePeriodChange}
                  usagePeriod={usagePeriod}
                  optionSelected={optionSelected}
                  handleUsagePeriodChange={this._handleUsagePeriodChange}
                  handleFocusChange={this._handleFocusChange}
                  isfromselected={isfromselected}
                  istoselected={istoseleced}
                  chartType={chartType}
                />
              )}
            </Grid>
          </Grid>
        )}
      </Page>
    )
  }
}
export default Tank
